import DocumentService from "../../service/DocumentService";
//import swal from 'sweetalert'

export const namespaced = true

export const state = {
    documents:[],
    documentsAdmin:[],
    isDocumentsUpt: false,
    updateDocumentsLoading: false,
    documentLoading: false,
    response: {}

}


export const getters = {
}


export const mutations = {
    updateDocuments: (state, payload) =>{
      state.documents = payload
    },
    updateDocumentsAdmin: (state, payload) =>{
      state.documentsAdmin = payload
    },
    updateResponse: (state, payload) =>{
        state.response = payload
    },
    updateIsDocumentsUpt: (state, payload) =>{
        // console.log('Entered Mutation updateIsDocumentsUpt', payload);
        state.isDocumentsUpt = payload;
    },
    updateDocumentLoading: (state, payload) =>{
        // console.log('Entered Mutation updateIsDocumentsUpt', payload);
        state.documentLoading = payload;
    },
    reset: (state, payload) =>{
        state.documents = [];
        state.documentsAdmin = [];
        state.isDocumentsUpt =  payload;
        state.updateDocumentsLoading =  false;
        state.documentLoading =  false;
        state.response =  {};

    },
}


export const actions = {
    updateDocuments: ({ commit }, payload)=>{
        // console.log("updateDocuments>>>>>>")
        if(state.documents.length < 1)
            commit("updateDocumentLoading", true)
            return DocumentService.callGetDocumentsApi(payload)
            .then(response => {
                if (response.data.responseCode === "00") {
                    commit("updateDocumentLoading", false)
                    // commit("updateIsUserInfoUpt", true)
                    let responseData = response.data;
                    commit("updateDocuments", responseData.data)
                }
                
            })
            .catch(error => {
                commit("updateDocumentLoading", false)
                alert(error)
                // throw error;
            });
    },
    updateDocumentsAdmin: ({ commit }, payload)=>{
        // console.log("updateDocuments>>>>>>")
            if(state.documents.length < 1)
                commit("updateDocumentLoading", true)
            return DocumentService.callGetDocumentsApi(payload)
            .then(response => {
                if (response.data.responseCode === "00") {
                    commit("updateDocumentLoading", false)
                    // commit("updateIsUserInfoUpt", true)
                    let responseData = response.data;
                    commit("updateDocumentsAdmin", responseData.data)
                }
                
            })
            .catch(error => {
                commit("updateDocumentLoading", false)
                alert(error)
                // throw error;
            });
    },
    createDocuments: ({ commit }, payload)=>{
        // console.log("createDocuments>>>>>>")
        commit("updateResponse", {})
        //commit("updateDocumentLoading", true)
            return DocumentService.callCreateDocumentApi(payload)
            .then(response => {
                if (response.data.responseCode === "00") {
                    //commit("updateDocumentLoading", false)
                    // commit("updateIsUserInfoUpt", true)
                    let responseData = response.data;
                    commit("updateResponse", responseData)
                }
                
            })
            .catch(error => {
                //commit("updateDocumentLoading", false)
                alert(error)
                // throw error;
            });
    },
    removeDocument: ({ commit }, payload)=>{
        // console.log("createDocuments>>>>>>")
        commit("updateResponse", {})
        //commit("updateDocumentLoading", true)
            return DocumentService.callRemoveDocumentApi(payload)
            .then(response => {
                if (response.data.responseCode === "00") {
                    commit("updateDocumentLoading", false)
                    // commit("updateIsUserInfoUpt", true)
                    let responseData = response.data;
                    commit("updateResponse", responseData)
                }
                
            })
            .catch(error => {
                //commit("updateDocumentLoading", false)
                alert(error)
                // throw error;
            });
    },
    updateDocStatus: ({ commit }, payload)=>{
        // console.log("createDocuments>>>>>>")
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateResponse", {})
        commit("updateDocumentLoading", true)
            return DocumentService.callUpdateDocStatusApi(payload)
            .then(response => {
                if (response.data.responseCode === "00") {
                    commit("updateDocumentLoading", false)
                    // commit("updateIsUserInfoUpt", true)
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert('Document status update successfully!', options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }else{
                    commit("updateDocumentLoading", false)
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(response.data.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                        });
                }
                
            })
            .catch(error => {
                commit("updateDocumentLoading", false)
                alert(error)
                // throw error;
            });
    },
    updateIsUserInfoUpt: ({ commit }, payload)=>{
        commit('updateIsUserInfoUpt', payload)
    },
    updateIsDocumentsUpt: ({ commit }, payload)=>{
        commit('updateIsDocumentsUpt', payload)
    },
    reset: ({ commit }, payload)=>{
        commit("reset",payload)
    }
}
